import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const AnalyticsPage = lazy(() => import('./pages/AnalyticsPage'));

export const AnalyticsRoutes: RouteObject = {
  path: 'analytics',
  children: [
    { path: '', element: <AnalyticsPage />, handle: { crumb: 'Web Vitals & Funnel Analytics' } },
  ],
};
